import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

function useAccountStatus() {
  const { cb, key } = fetch();

  const { data, isSuccess, refetch } = useQuery(key, cb);

  const isMtActive = data?.status_mt_account === 'ACTIVE';

  return { data, isSuccess, refetch, isMtActive };
}

export default {
  useAccountStatus,
};
